import { createSlice } from "@reduxjs/toolkit";
import { Action } from "history";
import { RootState } from "../../store";

 type StateType = {
    isOpen: boolean
}
const initialState : StateType = {
  isOpen: false
};

const LogoutSlicer = createSlice({
  name: "LogoutSlicer",
  initialState,
  reducers: {
    toggleModal: (state: StateType , payload: any) => {
      state.isOpen = payload.payload;
    },
  },
});
export const { toggleModal } =
LogoutSlicer.actions;

export const isOpenLogoutModal = (state: RootState) => state.logoutModal.isOpen;

export default LogoutSlicer.reducer;
